import { Container } from '@/components';
import React, { useState } from 'react';
import LoadFile from './LoadFile';
import MarginCalculatorByProduct from './MarginCalculatorByProduct';
import MarginCalculationByFile from './MarginCalculationByFile';

const MarginCalculator = () => {
  const [activeTab, setActiveTab] = useState('Load File');
  const tabs = [
    { name: 'Load File', component: <LoadFile /> },
    { name: 'Margin Calculator', component: <MarginCalculatorByProduct /> },
    {
      name: 'Margin Calculation By File',
      component: <MarginCalculationByFile />,
    },
  ];
  return (
    <Container title={'Margin Calculator'}>
      <div className="w-full p-6 bg-secondary font-400">
        {/* Tab Header Section */}
        <div className=" border-gray-300">
          <div className="flex">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(tab.name)}
                className={`px-6 py-3 text-sm font-semibold transition-all ${
                  activeTab === tab.name
                    ? 'text-black  border-[#ffb800] border-t-2 border-l-2 border-r-2 rounded-t-lg bg-gray-50'
                    : 'text-gray-500 hover:text-black border-b-2 border-[#ffb800]'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content Section */}
        <div className="">
          {tabs.find((tab) => tab.name === activeTab)?.component}
        </div>
      </div>
    </Container>
  );
};

export default MarginCalculator;
